import { render, staticRenderFns } from "./CountDownTip.vue?vue&type=template&id=724264c3&scoped=true&"
import script from "./CountDownTip.vue?vue&type=script&lang=js&"
export * from "./CountDownTip.vue?vue&type=script&lang=js&"
import style0 from "./CountDownTip.vue?vue&type=style&index=0&id=724264c3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "724264c3",
  null
  
)

export default component.exports